// extracted by mini-css-extract-plugin
export default {"status":"HealthConditionView_status__XTO2O","submenu":"HealthConditionView_submenu__08Doy","hide":"HealthConditionView_hide__d8-h9"};